module.exports = __webpack_public_path__ + "static/media/Valk6.3f1ab22f.png";